import React, { useState, useEffect } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { Card, CardHeader, Stack } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../Utils/Baseurl';
import axios from 'axios';
import { useUserDetails } from '../../context/auth'
const EmployeeSalary = () => {

    const navigate = useNavigate()
     const {AccessData,setEmpdisplay,setshowemp} = useUserDetails()
    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })

    const [employeeSalaryList, setEmployeeSalaryList] = useState([])

    useEffect(() => {
        onSalaryStructureSubmit();
    }, []);

    const SalaryStructureListTable = {
        columns: [
            {
                field: "empid",
                headerName: "Employee ID",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "firstName",
                headerName: "Employee Name",
                width: 200,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "ctc",
                headerName: "Annual CTC",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "totalBenefits",
                headerName: "Total Benefits",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "totalDeductions",
                headerName: "Total Deductions",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "netPay",
                headerName: "Net Salary (M)",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "gross",
                headerName: "Gross Salary (M)",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "salaryStructure",
                headerName: "Salary Structure",
                width: 200,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            
        ],
        rows: employeeSalaryList?.map(sal => {
            return {
                
                id: sal.id,
                empid:sal.user.empid,
                firstName: sal.user.firstName.toUpperCase(),
                ctc: sal.ctc,
                netPay : sal.netPay,
                gross: sal.gross,
                totalBenefits: sal.totalBenefits,
                totalDeductions: sal.totalDeductions,
                salaryStructure: sal.salaryStructure?.structureName,
                // monthlyGrossAmount : sal.monthlyGrossAmount,
                // netAmount: sal.netAmount,
                // monthlyNetAmount : sal.monthlyNetAmount,
                // structureName : sal.structureName
            }
        })
    }

    const handleNewSalaryStructure = () => {
        setEmpdisplay(false)
        setshowemp(false)
        navigate('/employee-salary/add-employee-salary')
    }

    const onEmployeeListClick = (e) => {
        console.log('onEmployeeListClick:', e?.id, e)
        if (e?.id) {
            setEmpdisplay(true)
            setshowemp(true)
            navigate(`/employee-salary/add-employee-salary?id=${e?.id}`)

        }
    }


    const onSalaryStructureSubmit = async () => {
        const query = `
           query AllEmployeesalary {
  allEmployeeCalcualtedsalary{
    id
    ctc
    gross
    totalDeductions
    totalBenefits
    netPay
    overallSum
    difference
    basicPercentage
    salaryStructure {
      id
      structureName
    }
    user {
      id
      firstName
      lastName
      empid
    }
    breakdown {
      type
      componentName
      percentage
      monthly
      yearly
    }
  }
}      `;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
             console.log("RESPONSE:",response.data);
             
            // Extract Employee data from the response
            const EmployeeSalaryResponse = response.data.data.allEmployeeCalcualtedsalary;
            // console.log("EmployeeSalaryResponse" ,response.data);
            setEmployeeSalaryList(EmployeeSalaryResponse);
            setPageState({ ...pageState, loading: false, state: 'success' });
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Employee Salary list
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of Employee Salary that you can get details of Employee Salary.
                            </MaterialTypography> */}
                        </Stack>
                        {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddEmployeeSalery" && item.can_access
                ) && (
                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewSalaryStructure()}
                        >
                            Configure Salary
                        </MaterialButton>
                )}
                    </Stack>


                )} />
                <MaterialDataGrid
                    // customHeight={550}
                    rows={SalaryStructureListTable.rows}
                    columns={SalaryStructureListTable.columns}
                    checkboxSelection={false}
                    isSelectable={false}
                    onRowClick={onEmployeeListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No employee salary found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any employee salary details. Click on the "Configure Salary" button to start adding employee salary details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default EmployeeSalary
